module.exports = __webpack_public_path__ + "assets/img/8c82-ad.svg";